/*
 * @Author: your name
 * @Date: 2021-06-28 12:14:49
 * @LastEditTime: 2021-11-29 16:41:12
 * @LastEditors: your name
 * @Description: yang
 * @FilePath: \web_bank\src\api\http.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
import axios from 'axios'
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.delete['Content-Type'] = 'application/json'
axios.defaults.headers.put['Content-Type'] = 'application/json'
// export const baseURL ="http://192.168.1.40:8097"
// export const baseURL ="http://192.168.1.152:8097"
export const baseURL ="https://api.qingzhou.link/api3"
  // // 请求拦截器
  axios.interceptors.request.use(
    config => {
      config.headers.appId = 'wx1dae94c709fdbcf8'
      // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
      // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
      console.log("请求了",config);
      if(config.url == baseURL+"/" || config.url == baseURL+"/manualBind"){
        console.log("不需要token")
        config.headers.Authorization = "";
        return config
      }else{
        if(sessionStorage.getItem('token')){
          console.log(sessionStorage.getItem('token'))
          const token = JSON.parse(sessionStorage.getItem('token'))
          config.headers.Authorization = token;
        }
          return config
      }
      
    },
    error => {
      return Promise.error(error)
    })

    // sessionStorage.setItem("token", JSON.stringify(res.token))

//获取AuthorizationCode授权码
export const getAuthorizationCode = (client_id,redirect_uri,state, scope) => {
    return axios({
        url: `https://openbank.abchina.com/OAuthServer/OAuth/Authorize?client_id=${client_id}&redirect_uri=${redirect_uri}&state=${state}&scope=${scope}&response_type=code`,
        method: 'get'
    })
}

//获取是否在农行登录
export const abcCode = () => {
  return axios({
      url: `https://openbank.abchina.com/OAuthServer/pages/pc/LogOnPage.html?client_id=82284001-7aad-49a7-8ca5-aecd5b9e9870&redirect_uri=https://apinh.sjzdezhong.com/payQuickly/api/payNotify.do?shName=OPENABCHDKE,1638174901009&state=9efcebe549&scope=openid&response_type=code`,
      method: 'get'
  })
}

//通过code获取openId

export const getOpenId = (code) => {
  return axios({
      url: baseURL + `/abc/assessCode?code=${code}&redirectUri=http://abc-bank.qingzhou.link/`,
      method: 'GET',
  })
}

 //校验openId
 export const checkBindd = (data) => {
    return axios({
        url: baseURL + '/abc/checkBind?openId='+data,
        method: 'GET',
    })
}
//获取手机验证码
export const getSms = (data) => {
  return axios({
      url: baseURL + '/abc/sendSms?phoneNumber='+data,
      method: 'post',
      headers: {
        "Authorization": "",
      },
  })
}

//验证手机验证码 /abc/verify/phone/SmsCode
export const smsCode = (tel,sms) => {
  return axios({
      url: baseURL + '/abc/verify/phone/SmsCode?phoneNumber='+tel+'&smsAuthCode='+sms,
      method: 'GET',
  })
}

//openid授权
export const bind = (data) => {
  return axios({
      url: baseURL + '/abc/bind',
      method: 'post',
      data
  })
}

//通过父母id查询孩子信息   https://api.qingzhou.link/api3/user/get/parent/369630/student/info
export const getChilgrenInfo = (id) => {
  return axios({
      url: baseURL + '/user/get/parent/'+id+'/student/info',
      method: 'GET',
  })
}

//获取学校的相册  https://api.qingzhou.link/api3/config/find/school_9_coverImage/CommonConfig      拿取数据JSON.parse(res.data.data.configValue)
export const getCoverImage = (schoolId) => {
  return axios({
      url: baseURL + '/config/find/school_'+schoolId+'_coverImage/CommonConfig',
      method: 'GET',
  })
}

//解除绑定  /abc/unbind?userId=1
export const jieChu = (userId) => {
  return axios({
      url: baseURL + '/abc/unbind?userId='+userId,
      method: 'post',
  })
}

//换取token   /abc/login/1?openId=1
export const getToken = (oppendId,schoolId) => {
  return axios({
      url: baseURL + '/abc/login/'+oppendId+'?openId='+schoolId,
      method: 'GET',
  })
}

//https://api.qingzhou.link/api3/yqsh/school/9/query/Balance?userId=377619    获取余额
export const getBalance = (schoolId,userId) => {
  return axios({
      url: baseURL + '/yqsh/school/'+schoolId+'/query/Balance?userId='+userId,
      method: 'GET',
  })
}

//获取今日消费 https://api.qingzhou.link/api3/yqsh/school/43/query/Fin
export const getFin = (schoolId,data) => {
  return axios({
      url: baseURL + '/yqsh/school/'+schoolId+'/query/Fin',
      method: 'post',
      data
  })
}

//获取充值列表
export const getPoscardChargeList = (schoolId) => {
  let data= {
    schoolId: schoolId,
    tag: "poscard_charge"
  }
  return axios({
      url: baseURL + '/product/list',
      method: 'post',
      data
  })
}

//获取充值机记录
export const getMoneyHistory = (data) => {
  return axios({
      url: baseURL + '/order/list/order/records',
      method: 'post',
      data
  })
}
//查询部门主管所管理的班级
export const getClass = (data) => {
  return axios({
      url: baseURL + `/user/get/manager/${data}/department`,
      method: 'put',
      data
  })
}
//根据部门ID获取部门下所有学生
export const getStudents = (data) => {
  return axios({
      url: baseURL + '/user/findUserPage',
      method: 'post',
      data
  })
}
//获取学校的组织数
export const getSchool = (data) => {
  return axios({
      url: baseURL + `/org/${data}/orgTree`,
      method: 'get',
      data
  })
}
//提交请假信息
export const getLeave = (data) => {
  return axios({
      url: baseURL + `/leave/create/batch/studentLeaveRecords`,
      method: 'put',
      data
  })
}
//获取用户对应的请假记录   1代表我提交的  2代表待我审批的   3代表已经完成的
export const getLeaveInfo = (pageNum,pageSize,relType) => {
  return axios({
      url: baseURL + `/leave/school/studentRecords?pageNum=${pageNum}&pageSize=${pageSize}&relType=${relType}`,
      method: 'get',
  })
}
//批准或者驳回请假单
export const successLeave = (data) => {
  return axios({
      url: baseURL + `/leave/approves/studentLeaveRecord`,
      method: 'put',
      data
  })
}
//转发请假单
export const zhuanfaLeave = (leaveId,remark,userId) => {
  return axios({
      url: baseURL + `/leave/forward/leave/${leaveId}/to/user/${userId}/?remark=${remark}`,
      method: 'put',
  })
}
//撤销请假单
export const cheXiaoLeave = (data) => {
  return axios({
      url: baseURL + `/leave/record/leaveState`,
      method: 'post',
      data
  })
}
//获取学校的快e通code
export const getEcode = (schoolId) => {
  return axios({
      url: baseURL + `/abc/get/epay/code?schoolId=${schoolId}`,
      method: 'get',
  })
}
// 获取学校信息
export const getSchoolInfo = (schoolId) =>{
  return axios({
    url: baseURL + '/org/' + schoolId + '/info',
    method: 'get',
  })
}